import { useSession } from "./session"

export function useRole() {
	const { session } = useSession()

	return { role: session?.membershipRole }
}
